import React, { useState } from "react";

import { message, Spin } from "antd";

import Header from "../../components/Header";
import "./styles.scss";
import { saveAxiosBlobAs } from "../../helpers/saveAxiosBlobAs";
import { exportarRelatorioAtividadesRecentes } from "../../services/http/atividadeRecenteService";

const Log = () => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState({
    data: null,
    mes: null,
    ano: null,
  });

  const excelRelatorioAtividadesRecentes = async() => {
    if (data.mes && !data.ano) {
      message.error("Insira um ano para prosseguir.");
      return;
    }

    const response = await exportarRelatorioAtividadesRecentes(data.ano, data.mes, data.data);
    saveAxiosBlobAs(response);
  };
  return (
    <Spin spinning={loading}>
      <Header style={{ marginBottom: "2rem" }} />
      <div className="container">
        <div className="row">
          <div className="col-md-12 col-sm-12">
            <div className="col-lg-12 col-md-12 col-sm-12 div-galeria-opcoes">
              <span className="titulo-listagem">Log de movimentação</span>
            </div>
            <div className="row">
              <hr className="linha" />
            </div>
            <div className="row">
              <div className="col-md-3 col-sm-3 ">
                <label>Data alteração:</label>
                <input
                  className="input-log"
                  type="date"
                  onChange={(e) => {
                    const value = e.target.value;
                    const formattedValue = value.slice(0, 10);
                    setData((prev) => ({ ...prev, data: formattedValue }));
                  }}
                  value={data.data}
                />
              </div>
              <div className="col-md-2 col-sm-2 ">
                <label>Mês:</label>
                <select
                  className="input-log"
                  onChange={(e) =>
                    setData((prev) => ({ ...prev, mes: e.target.value }))
                  }
                  value={data.mes}
                >
                  <option value=""></option>
                  <option value="1">Janeiro</option>
                  <option value="2">Fevereiro</option>
                  <option value="3">Março</option>
                  <option value="4">Abril</option>
                  <option value="5">Maio</option>
                  <option value="6">Junho</option>
                  <option value="7">Julho</option>
                  <option value="8">Agosto</option>
                  <option value="9">Setembro</option>
                  <option value="10">Outubro</option>
                  <option value="11">Novembro</option>
                  <option value="12">Dezembro</option>
                </select>
              </div>
              <div className="col-md-2 col-sm-2  ">
                <label>Ano:</label>
                <select
                  className="input-log"
                  value={data.ano}
                  onChange={(e) =>
                    setData((prev) => ({ ...prev, ano: e.target.value }))
                  }
                >
                  <option value=""></option>
                  {Array.from(
                    { length: new Date().getFullYear() - 2021 + 1 },
                    (_, i) => 2021 + i
                  )
                    .reverse()
                    .map((ano) => (
                      <option key={ano} value={ano}>
                        {ano}
                      </option>
                    ))}
                </select>
              </div>

              <div className="col-md-3 col-sm-3">
                <button
                  className="gerarRelatorio"
                  onClick={() => excelRelatorioAtividadesRecentes()}
                >
                  Gerar relatório
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Spin>
  );
};

export default Log;
